import React from 'react';
import ProductPage from '../components/ProductPage';
import useDocumentTitle from '../hooks/useDocumentTitle';
import PrzyciskAsystenta from '../components/kreator/PrzyciskAsystenta';
import { useTranslation } from 'react-i18next';

const Inverters = () => {
  const { t } = useTranslation('lista');
  useDocumentTitle(t('tytul_strony.inwerter'));
  return (
    <div className='space-y-10'>
      {/* Wejście do asystenta w PASKU NAGŁÓWKA listingu, między okruszkami
          a przełącznikiem widoku — zostaje na ekranie razem z listą, więc widzi
          je także ktoś, kto zorientował się dopiero po kilku pozycjach, że nie
          umie wybrać. */}
      <ProductPage
        productType="inwerter"
        akcja={(
          <PrzyciskAsystenta
            to="/dobor-falownika"
            tytul={t('asystent.inwerter')}
            narzedzie={t('asystent.narzedzie')}
          />
        )}
      />
    </div>
  )
}

export default Inverters;
